import BeSimpleAPI from '@/providers/api/';

import { baseActions } from './../base_actions';
import { baseMutations } from './../base_mutations';

const state =
{
    api: new BeSimpleAPI(process.env.VUE_APP_CARPETLINE_API_URL),
    'user-customer-relations': {
        shared: false,
        items: [],
        item: {}
    },
    'orders': {
        shared: false,
        items: [],
        item: {}
    },
    'order-statuses': [ 
        { key: 0, value: 'In afwachting van tapijt' }, 
        { key: 1, value: 'In behandeling'},
        { key: 2, value: 'Afgerond'}
    ],
    'semi-finishes': {
        shared: false,
        items: [],
        item: {}
    }
};

const getters = {
    //List getters
    usercustomerrelations: state => state['user-customer-relations'].items,
    orders: state => state['orders'].items,
    orderStatuses: state=> state['order-statuses'],
    semiFinishes: state => state['semi-finishes'].items,
    
    //Single getters
    order: state=> state['orders'].item,
    usercustomerrelation: state=> state['user-customer-relations'].item
};

const actions = {
    ...baseActions
}

const mutations = {
    ...baseMutations
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
